export const TYPES_FOR_PRELOAD_ABOVE_FOLD = new Set(['coupe']);
